import { injectable, inject } from 'inversify';
import { IKeyboardShortcutService, IKeyboardShortcutHandler, IKeyboardShortcutHandlerProvider } from '@/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service-interface';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IModalManagerService } from '@/app-modules/modal-manager/modal-manager-service';
import { ModalManagerPlugin } from '@/plugins/modal-manager';

@injectable()
class KeyboardShortcutService implements IKeyboardShortcutService {
  private readonly keyboardShortcutHandlerProvider: IKeyboardShortcutHandlerProvider;
  private readonly modalManagerService: IModalManagerService;
  private currentKeyboardShortcutHandler: IKeyboardShortcutHandler | null;
  private currentKeyboardEvent: KeyboardEvent;

  private get modalManager(): ModalManagerPlugin {
    return this.modalManagerService.getModalManager();
  }

  constructor(@inject(SERVICE_IDENTIFIERS.IKeyboardShortcutHandlerProvider) keyboardShortcutHandlerProvider: IKeyboardShortcutHandlerProvider,
              @inject(SERVICE_IDENTIFIERS.IModalManagerService) modalManagerService: IModalManagerService) {
    this.keyboardShortcutHandlerProvider = keyboardShortcutHandlerProvider;
    this.modalManagerService = modalManagerService;
  }

  public processKeyboardEvent(keyboardEvent: KeyboardEvent): boolean {
    if (keyboardEvent.key === 'F7') {
      return this.processWindowSwitchKeyboardEvent(keyboardEvent);
    }

    this.setCurrentKeyboardEvent(keyboardEvent);
    this.chooseKeyboardEventShortcutHandlerForCurrentKeyboardEvent();
    return this.processCurrentKeyboardEvent();
  }

  private chooseKeyboardEventShortcutHandlerForCurrentKeyboardEvent(): void {
    let keyboardShortcutHandlers = this.keyboardShortcutHandlerProvider.getAllHandlers();
    keyboardShortcutHandlers = keyboardShortcutHandlers.filter(this.filterKeyboardShortcutHandlerForCurrentKeyboardEvent, this);
    this.currentKeyboardShortcutHandler = (keyboardShortcutHandlers && keyboardShortcutHandlers.length > 0) ? keyboardShortcutHandlers[0] : null;
  }

  private setCurrentKeyboardEvent(currentKeyboardEvent: KeyboardEvent): void {
    this.currentKeyboardEvent = currentKeyboardEvent;
  }

  private filterKeyboardShortcutHandlerForCurrentKeyboardEvent(keyboardShortcutHandler: IKeyboardShortcutHandler): boolean {
    return keyboardShortcutHandler.canProcessKeyboardEvent(this.currentKeyboardEvent);
  }

  private processCurrentKeyboardEvent(): boolean {
    if (this.currentKeyboardShortcutHandler != null) {
      this.currentKeyboardShortcutHandler.processKeyboardEvent(this.currentKeyboardEvent);
      return true;
    }
    return false;
  }

  private processWindowSwitchKeyboardEvent(keyboardEvent: KeyboardEvent): boolean {
    const shortcutId = parseInt(keyboardEvent.key, 10);
    if (!isNaN(shortcutId)) {
      const modalShortcut = this.modalManager.getShortcutHintByShortcutId(shortcutId);
      if (modalShortcut) {
        this.modalManager.bringToFront(modalShortcut.modalGuid);
        return true;
      }
    }
    return false;
  }
}

export { KeyboardShortcutService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service.ts